import { useLang } from 'hooks/lang';

import { loaders } from 'entities';
import { FolderLinkIcon } from 'components/Icons';

import { LabeledSelect } from 'components/Blocks';

import { ProjectTypeProps } from '.';

export function TrackerSequence({ projectType, dispatch }: ProjectTypeProps): JSX.Element {
  const { t } = useLang();

  const { data, loading } = loaders.projects.activeTrackerOrigins.use({
    defaultValue: [],
  });

  const options = data.map(({ waves, wavesLeft, id, name }) => ({
    id,
    label: `${name} (${wavesLeft}/${waves})`,
  }));

  return (
    <LabeledSelect
      id="project-origin"
      label={t('origin-project') || ''}
      labelIcon={FolderLinkIcon}
      loading={loading}
      options={options}
      value={projectType.originProject || ''}
      onChangeDirect={(originProject) =>
        dispatch({ typeConfig: (old) => ({ ...old.typeConfig, originProject }) })
      }
    />
  );
}
